import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ContributionsList from './contributions_list'
import { publicContributionsListSelector } from 'redux/selectors/contributions'
import { getCampaignSelector } from 'redux/selectors/campaign'
import cssModules from 'react-css-modules'
import styles from './public_contributions_list.less'
import ChipInButton from '../pages/campaign/chip_in_button'
import { daysFromToday } from 'shared/helpers/datetime_helpers'
import { getI18n } from 'client/i18n'
import { formatMoney, getFullName } from 'client/griffin'
import PublicContributionRow from './rows/public_contribution_row'

const i18n = getI18n('components/txns_list')

class UnboundPublicContributionsList extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    contributions: PropTypes.array,
    txnsPerPage: PropTypes.number.isRequired,
    txnCount: PropTypes.number,
    goalRemaining: PropTypes.number,
    daysRemaining: PropTypes.number,
    currency: PropTypes.string.isRequired,
    ownerName: PropTypes.string.isRequired,
    canChipIn: PropTypes.bool.isRequired,
    preview: PropTypes.bool,
    onChipInClick: PropTypes.func,
  }

  static defaultProps = {
    txnCount: 0,
  }

  formattedAttention = () => {
    let stringId
    if (this.props.goalRemaining) {
      if (this.props.daysRemaining) {
        stringId = 'attention_goal_and_days_{days}'
      } else {
        stringId = 'attention_goal_only'
      }
    } else if (this.props.daysRemaining) {
      stringId = 'attention_days_only_{days}'
    }
    return stringId
      ? i18n(stringId, {
          amount: formatMoney(this.props.currency, this.props.goalRemaining, {
            removeTrailingZeros: true,
          }),
          days: this.props.daysRemaining,
        })
      : ''
  }

  shouldShowCallToChipIn = () => {
    return this.props.canChipIn && this.props.goalRemaining > 0
  }

  shouldSkipRenderingList = () => {
    return !this.shouldShowCallToChipIn() && !this.props.contributions
  }

  render() {
    if (this.shouldSkipRenderingList()) return null

    const ContributionsCount = cssModules(
      ({ count }) => (
        <div styleName="contributions-count">
          {i18n('contributions_{count}', { count })}
        </div>
      ),
      styles
    )

    const ChipInCTA =
      this.shouldShowCallToChipIn() &&
      cssModules(
        ({ name, attentionMessage }) => (
          <div styleName="cta-container">
            <div styleName="help">
              <div styleName="help-details">
                <div styleName="help-title">
                  {i18n('help_organizer', { name })}
                </div>
                <div styleName="attention">{attentionMessage}</div>
              </div>
              <div styleName="help-action" className="hidden-xs">
                <ChipInButton
                  secondary={true}
                  reveresed={false}
                  small={true}
                  campaignId={this.props.campaignId}
                />
              </div>
            </div>
          </div>
        ),
        styles
      )

    return (
      <ContributionsList
        campaignId={this.props.campaignId}
        showTxnsDates={true}
        preview={this.props.preview}
        contributions={this.props.contributions}
        topElement={<ContributionsCount count={this.props.txnCount} />}
        bottomElement={
          ChipInCTA ? (
            <ChipInCTA
              name={this.props.ownerName}
              attentionMessage={this.formattedAttention()}
            />
          ) : (
            undefined
          )
        }
        rowElement={(contribution, key) => (
          <PublicContributionRow
            {...contribution}
            key={key}
            preview={this.props.preview}
          />
        )}
      />
    )
  }
}

export default connect((state, props) => {
  const campaign = getCampaignSelector(state, props)
  let daysRemaining
  if (campaign.end_date != null) {
    daysRemaining = daysFromToday(new Date(campaign.end_date))
  }

  let goalRemaining
  const currentValue = campaign.current_value + campaign.pledge
  if (campaign.goal != null && currentValue != null) {
    goalRemaining = campaign.goal - currentValue
  }

  return {
    contributions: publicContributionsListSelector(state, props),
    txnsPerPage: props.txnsPerPage || state.txns.txns_per_page,
    txnCount: campaign.txn_count,
    goalRemaining,
    daysRemaining,
    preview: campaign.preview,
    canChipIn: campaign.can_chip_in,
    currency: campaign.currency,
    ownerName: getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    }),
  }
})(cssModules(UnboundPublicContributionsList, styles))
